import { ServiceType } from "@agroyaar/sdk";

export function reportTitle(serviceType: ServiceType): string {
  const titleMap: Partial<Record<ServiceType, string>> = {
    CROPPING_PATTERN: "گزارش الگو کشت",
    CROPPING_SUITABILITY: "گزارش تناسب کشت",
  };

  return titleMap[serviceType] ?? "";
}
